import React from "react";
import Layout from "../../components/Layout/Layout";
import Feedback from "../../components/general/Feedback/Feedback";
import Cards from "../../components/pages/Gifts/Cards/Cards";
import UseConditions from "../../components/pages/Gifts/UseConditions/UseConditions";

const GiftsPage: React.FC = () => {
  return (
    <Layout>
      <Cards />
      <UseConditions />
      <Feedback />
    </Layout>
  );
};

export default GiftsPage;
